import { isFieldAPaymentField } from 'FormsUI/utils/FormFieldsUtils';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { UnknownProperties } from 'forms-utils-lib/constants/Properties';
export const getPaymentTestHrefFromId = (paymentsData, id) => {
  const specificPayment = paymentsData.find(({
    id: paymentId
  }) => paymentId === id);
  return specificPayment && specificPayment.testCheckoutUrl;
};
export const isFormTypeApprovedForPayments = formType => formType === FormTypes.HUBSPOT;
export const getPaymentOptionsExcludingSelectedOptions = (paymentData, paymentField, valueSelected) => {
  const baseOptions = paymentData.filter(({
    id
  }) => !paymentField.options.map(({
    value: fieldValue
  }) => Number(fieldValue)).includes(id));
  if (paymentData.some(({
    id
  }) => id === Number(valueSelected))) {
    return [...baseOptions, paymentData.find(({
      id
    }) => id === Number(valueSelected))];
  }
  return baseOptions;
};
export const noPaymentLinksOnForm = options => !options || !options.length || options.every(({
  value
}) => !value);
export const paymentLinkOnForm = options => options && options.length && options.some(({
  value
}) => value);
export const notMoreThanOneValidPaymentLink = options => noPaymentLinksOnForm(options) || options.filter(({
  value
}) => value).length <= 1;
export const getIsNoMoreOptions = (paymentData, options) => paymentData.length === options.length;
export const getIsAnyRowInvalid = options => options.filter(({
  value
}) => !value).length >= 1;
export const getShouldDisableAddPaymentOption = (paymentData, options) => getIsNoMoreOptions(paymentData, options) || getIsAnyRowInvalid(options);
export const paymentOptionsHaveChanged = (draftOptions, publishedOptions) => {
  const draftOptionSessionIds = draftOptions.map(({
    value
  }) => value);
  const publishedOptionSessionIds = publishedOptions.map(({
    value
  }) => value);
  return !publishedOptionSessionIds.every(element => draftOptionSessionIds.includes(element));
};
export const getIsPaymentFieldGroup = (formFieldGroup, paymentsConfigured) => {
  if (!formFieldGroup || formFieldGroup.fields.length !== 1) {
    return false;
  }
  const paymentField = formFieldGroup.fields.find(formField => isFieldAPaymentField(formField));
  if (!paymentField) return false;
  if (!paymentsConfigured) return true;
  return notMoreThanOneValidPaymentLink(paymentField.options);
};
export const hidePaymentFieldGroup = (formFieldGroup, paymentsConfigured) => !getIsPaymentFieldGroup(formFieldGroup, paymentsConfigured);
export const getIsSinglePaymentLink = formField => formField && formField.options.length === 1;
export const getIsMultiplePaymentLinks = formField => formField && formField.options.length > 1;
export const getLinkGroupIndexByField = (formFieldGroups, field) => {
  const fieldName = field.name;
  return formFieldGroups.findIndex(formFieldGroup => {
    return formFieldGroup.fields.find(i => i.name === fieldName);
  });
};
export const getPaymentLinkGroupIndex = formFieldGroups => {
  return formFieldGroups.findIndex(formFieldGroup => {
    return formFieldGroup.fields.find(i => i.name === UnknownProperties.PAYMENT_LINK);
  });
};
export const getSinglePaymentLinkLabel = field => field.options[0].label;